import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { OWNERSHIP_CHANGE_PACKET } from "./apiRoutes";

interface UseGetClosingProofListProps {
  ocpId: string;
  ocpStage: "CLOSING_PACKAGE" | "OWNER_ONBOARDING" | "OWNERSHIP_CHANGE_DOC";
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getClosingProofList = async ({ocpId, ocpStage}: UseGetClosingProofListProps) =>
  await axiosAuth.get(`${OWNERSHIP_CHANGE_PACKET}/${ocpId}/documents?ocpStage=${ocpStage}`);

const useGetClosingProofList = ({
  ocpId,
  ocpStage,
  queryParams,
}: UseGetClosingProofListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["closing-proof-list", ocpId],
    queryFn: () => getClosingProofList({ocpId, ocpStage}),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!ocpId,
    ...queryParams,
  });
};

export default useGetClosingProofList;
